<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="resumen/adeudos"></app-filtros-reportes>


      <div style="overflow:auto; height: 77.5vh;">
        
        <div id="imprimir">
            <!--Tabla -->

            <table class="table is-striped  is-fullwidth" *ngIf="!cargando " id="tabla">
                <thead>
                    <tr>
                        <th>Alumno</th>
                        <th>Esatus</th>
                        <th>Periodo</th>
                        <th>Carrera</th>
                        
                        <th>Grupo</th>
                        <th>Nivel </th>
                        <th>Importe </th>
                        <th>Recargo </th>
                        <th>Total </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of ctrl.datos; let i=index">
                        <th>{{ item.alumno }}</th>
                        <th>{{ item.estatus }}</th>
                        <th>{{ item.periodo }}</th>
                        <th>{{ item.carrera }}</th>
                        <th>{{ item.grupo }}</th>
                        <th>{{ item.nivel }}</th>
                        <td style="vertical-align: middle;">{{item.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                        <td style="vertical-align: middle;">{{item.recargo | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                        <td style="vertical-align: middle;">{{item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}} </td>

                    </tr>
                    <tr *ngIf="datos.length == 0">
                        <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                    </tr>
                </tbody>
            </table>
            <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla2">
                <thead>
                    <tr>
                        <th align="right">
                            <div align="right">Subtotal</div>
                        </th>
                        <th>
                            <div align="left">{{ctrl.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                        </th>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr>
                        <th align="right">
                            <div align="right">Recargo</div>
                        </th>
                        <th></th>
                        <th>
                            <div align="left">{{ctrl.recargo | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                        </th>
                        <th></th>
                    </tr>
                    <tr>
                        <th align="right">
                            <div align="right">Total</div>
                        </th>
                        <th></th>
                        <th></th>
                        <th >
                            <div align="left">{{ctrl.gran_total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                        </th>
                    </tr>
                </thead>
            </table>
            
        </div>
      </div>
    </div>
  </div>
</div>
